import { APIError, APIErrorType, NotVerifiedError, Session, errorToString, InvalidSubscriptionError, SubscriptionInfo } from "bpm-client-api";

export function downloadOrCrateMessageHandler(err: APIError, config: { target: HTMLElement, desiredPosition: string } | undefined, context: { props: { showToast: (arg0: string, arg1: string) => void; }; }) {
    if (err.type == APIErrorType.InvalidSubscriptionError) {
        if (config && (err as InvalidSubscriptionError).current_supscription == SubscriptionInfo.None) {
            config.target.setAttribute('data-balloon', 'Get Full Access. Purchase a Membership Now.')
            config.target.setAttribute('data-balloon-visible', '')
            config.target.setAttribute('data-balloon-pos', config.desiredPosition)
        } else {
            Session.getSubscriptionHandler() && Session.getSubscriptionHandler()!((err as InvalidSubscriptionError))
        }
    } else if (err.type == APIErrorType.NotVerifiedError) {
        if (!config) {
            Session.getUserNotVerifiedHandler()((err as NotVerifiedError))
        } else {
            if ((err as NotVerifiedError).submission_pending) {
                config.target.setAttribute('data-balloon', 'Get full access. Request a membership now.')
            } else {
                config.target.setAttribute('data-balloon', 'Your membership request is under review.')
            }
            config.target.setAttribute('data-balloon-visible', '')
            config.target.setAttribute('data-balloon-pos', config.desiredPosition)
        }
    } else {
        errorToString(err).forEach(str => {
            context.props.showToast('danger', str)
        })
    }
}


// WEBPACK FOOTER //
// ./src/manager/errormessagehandler.ts